import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { postLink } from '../components/blogStore';
import { fetchPosts } from '../services/api';
import './BlogPostPage.css';

export default function BlogListingPage() {
  const [posts,  setPosts]  = useState([]);
  const [filter, setFilter] = useState('All');
  const [imgErr, setImgErr] = useState({});

  useEffect(() => {
    fetchPosts().then(setPosts).catch(() => {});
    document.title = 'Blog — CropGuard AI | Crop Disease Articles';
    return () => { document.title = 'CropGuard AI — Crop Disease Detection'; };
  }, []);

  const tags    = ['All', ...Array.from(new Set(posts.map(p => p.tag)))];
  const visible = filter === 'All' ? posts : posts.filter(p => p.tag === filter);

  return (
    <div className="bp-blog-listing">
      <div className="bp-blog-listing-inner">

        <Link to="/" style={{ color:'#52b788', textDecoration:'none', fontSize:'.85rem', display:'inline-flex', alignItems:'center', gap:'6px', marginBottom:'32px' }}>
          ← Back to Home
        </Link>

        <div className="bp-listing-header">
          <h1>Agricultural Insights</h1>
          <p>Latest articles on crop disease prevention and modern farming techniques</p>
          <div style={{ marginTop:'20px', display:'flex', gap:'8px', justifyContent:'center', flexWrap:'wrap' }}>
            {tags.map(t => (
              <span key={t} onClick={() => setFilter(t)} style={{
                padding:'7px 18px', borderRadius:'50px', cursor:'pointer', fontSize:'.82rem', fontWeight:'600',
                background: filter === t ? 'rgba(82,183,136,.2)' : 'rgba(26,58,38,.4)',
                border: `1px solid ${filter === t ? 'rgba(82,183,136,.5)' : 'rgba(82,183,136,.15)'}`,
                color: filter === t ? '#52b788' : '#6b9e80', transition:'all .2s'
              }}>{t}</span>
            ))}
          </div>
        </div>

        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(300px, 1fr))', gap:'24px' }}>
          {visible.map(p => (
            <Link key={p.id} to={postLink(p)} style={{ textDecoration:'none' }}>
              <div style={{
                background:'rgba(26,58,38,.4)', border:'1px solid rgba(82,183,136,.12)',
                borderRadius:'20px', overflow:'hidden', transition:'transform .3s, border-color .3s', height:'100%'
              }}
                onMouseEnter={e => { e.currentTarget.style.transform='translateY(-6px)'; e.currentTarget.style.borderColor='rgba(82,183,136,.4)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform=''; e.currentTarget.style.borderColor='rgba(82,183,136,.12)'; }}
              >
                <div style={{ position:'relative', height:'200px', overflow:'hidden' }}>
                  {p.cardImg && !imgErr[p.id]
                    ? <img src={p.cardImg} alt={p.title} style={{ width:'100%', height:'100%', objectFit:'cover' }} onError={() => setImgErr(prev => ({...prev,[p.id]:true}))} />
                    : <div style={{ width:'100%', height:'100%', background:p.bg, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'3.5rem' }}>{p.emoji}</div>
                  }
                  <span style={{ position:'absolute', top:'12px', left:'12px', fontSize:'.68rem', padding:'4px 12px', borderRadius:'50px', background:'rgba(10,26,16,.85)', color:'#52b788', border:'1px solid rgba(82,183,136,.35)', fontWeight:'600' }}>{p.tag}</span>
                </div>
                <div style={{ padding:'22px' }}>
                  <div style={{ fontFamily:"'Playfair Display',serif", fontSize:'1rem', color:'#f0ebe3', marginBottom:'8px', lineHeight:'1.45' }}>{p.title}</div>
                  <div style={{ fontSize:'.84rem', color:'#6b9e80', lineHeight:'1.6', marginBottom:'14px' }}>{p.excerpt}</div>
                  <div style={{ fontSize:'.78rem', color:'#6b9e80', display:'flex', justifyContent:'space-between' }}>
                    <span>📅 {p.date} · ⏱ {p.readTime} read</span>
                    <span style={{ color:'#52b788', fontWeight:'600' }}>Read →</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
